// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import jquery from 'jquery'
import moment from 'moment'
import accounting from 'accounting'
import router from './router'
import Cookie from 'vue-cookie'
import Resource from 'vue-resource'
import Bootstrap from 'bootstrap'
import VTooltip from 'v-tooltip'
import VueChatScroll from 'vue-chat-scroll'
import VueBreadcrumbs from 'vue-breadcrumbs'
import swal from 'sweetalert'
import { Popover } from 'bootstrap-vue/es/components';
import Paginate from 'vuejs-paginate'
import Notifications from 'vue-notification'
import fieldGame from "@/components/form/fieldGame.vue"

Vue.use(Notifications)
Vue.use(Popover);
Vue.component('paginate',Paginate);

import oauth from '@/mixins/oauth2'
Vue.mixin(oauth);

import fieldCompetitor from "@/components/form/fieldCompetitor.vue"
import fieldDatetime from "@/components/form/fieldDatetime.vue"
import fieldTelephone from "@/components/form/fieldTelephone.vue"
import fieldUser from "@/components/form/fieldUser.vue"
import fieldGames from '@/components/form/fieldGames.vue'
import fieldAmountRange from "@/components/form/fieldAmountRange.vue"

import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import FlagIcon from 'vue-flag-icon'
import VueTabs from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css'
import VueLocalForage from 'vue-localforage'
import BootstrapVue from 'bootstrap-vue'
import { Collapse } from 'bootstrap-vue/es/components';

import paginate from 'vuejs-paginate';

Vue.use(Collapse);

import Chart from 'chart.js'
import 'choices.js/assets/styles/css/choices.min.css';
import 'handsontable/dist/handsontable.full.css';

Vue.use(VueTabs)

import { Dropdown } from 'bootstrap-vue/es/components';

Vue.use(Dropdown);

import { Layout } from 'bootstrap-vue/es/components';

Vue.use(Layout);

import { Button } from 'bootstrap-vue/es/components';

Vue.use(Button);

import { Form } from 'bootstrap-vue/es/components';

Vue.use(Form);

import { FormInput } from 'bootstrap-vue/es/components';

Vue.use(FormInput);

import { FormGroup } from 'bootstrap-vue/es/components';

Vue.use(FormGroup);

import { InputGroup } from 'bootstrap-vue/es/components';

Vue.use(InputGroup);

import 'fullpage.js/dist/fullpage.css'
import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
// import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import VueFullPage from 'vue-fullpage.js'

Vue.use(VueFullPage);

import Choices from 'choices.js'

import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.min.css';
// Init plugin
Vue.use(Loading);
Vue.component('paginate', paginate)
Vue.component('loading', Loading)

Vue.component('SweetModal', SweetModal)
Vue.component('SweetModalTab', SweetModalTab)
Vue.use(SweetModal)
Vue.use(SweetModalTab)
Vue.use(VueLocalForage)

Vue.component("fieldCompetitor", fieldCompetitor);
Vue.component("fieldDatepicker", fieldDatetime);
Vue.component("fieldTelephone", fieldTelephone);
Vue.component("fieldGames", fieldGames);
Vue.component("fieldUser", fieldUser);
Vue.component("fieldAmountRange", fieldAmountRange);
Vue.component("fieldGame", fieldGame);

import bTab from 'bootstrap-vue/es/components/tabs/tab';
import bTabs from 'bootstrap-vue/es/components/tabs/tabs';
import cLoader from '@/components/ui/loader/cloader'

Vue.component('b-tab', bTab);
Vue.component('b-tabs', bTabs);
Vue.component('cloader', cLoader);

Vue.use(VueChatScroll)
Vue.use(VTooltip)
Vue.directive('tooltip', VTooltip.VTooltip)

import VueIntro from 'vue-introjs'
Vue.use(VueIntro);
Vue.config.devtools = true;
import 'intro.js/introjs.css';
window.pendingTransactions = {payment: {total: 0}, withdrawal: {total: 0}};

window.scheme = 'https:';
window.apphost = 'tip24.bet';
window.api = '';
window.wsapi = 'wss://plysport.com/';
//window.bsapi = location.protocol+'//stage.plysport.com/';
window.bsapi = window.scheme+'//eu.exquo.net/';
window.session = new Object;
window.loading = 0;

if (window.location.hostname == 'localhost') {
   // window.scheme = 'http:';
   // window.apphost = 'sp.co';
    window.wsapi = 'ws://bs.co';
   // window.bsapi = window.scheme+'//bs.co/';
    //window.bsapi = location.protocol+'//plyfeed.com/';
   // window.bsapi = window.scheme+'//stage.plysport.com/';
}

window.auth = new Object;
window.accessTokenHeader = null;

Vue.use(FlagIcon);
Vue.use(Resource);
Vue.use(Cookie);
Vue.config.productionTip = false;
Vue.http.options.emulateJSON = true;

Vue.use(VueBreadcrumbs, {
    template: '<ul class="breadcrumb" v-if="$breadcrumbs.length"> ' +
    '<li class="breadcrumb-item"><router-link :to="{ name: \'home\' }">{{ $root.t.navigation[\'home\'] }}</router-link></li>' +
    '<li class="breadcrumb-item" v-for="(crumb, key) in $breadcrumbs">' +
      '<span v-if="$route.meta.breadcrumb == crumb.name">{{ $root.t.navigation[crumb.name.toLowerCase()] }}</span>' +
      '<router-link :to="linkProp(crumb)" :key="key" v-if="$route.meta.breadcrumb != crumb.name">{{ $root.t.navigation[crumb.name.toLowerCase()] }}</router-link></li> ' +
    '</ul>'
});

Vue.http.interceptors.push((request, next) => {

    request.timeout = 0;

    function getCookie(name) {
    function escape(s) { return s.replace(/([.*+?\^${}()|\[\]\/\\])/g, '\\$1'); };
    var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
    return match ? match[1] : null;
}

if(request.url.match(bsapi) && typeof window.auth.accessToken !== 'undefined') {
    request.headers.set('X-App-Session', 'Bearer '+window.auth.accessToken);
}
else if( !request.url.match('api/v1/get/client') && typeof window.auth.accessToken !== 'undefined' ) {

    /*
    if (!request.params.access_token) {
        if (!request.url.match('access_token=')) {
            if (request.params != 0) {

                request.params.access_token = window.auth.accessToken;
            }
        }
    } */
    request.headers.set('Authorization', 'Bearer '+window.auth.accessToken);
    request.headers.set('X-Token', window.auth.accessToken);
}
request.params.locale = "en"

//console.log(request);
next()
})

const EventBus = new Vue()

Object.defineProperties(Vue.prototype, {
    $bus: {
        get: function () {
            return EventBus
        }
    }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
    data: {
        moment: moment
    },
  template: '<App />',
  components: { App }
})

var mixin = {
    methods: {
        showInfo () {
          this.$intro().start();
        },
        showHints () {
          this.$intro().showHints();
        },
        hideeHints () {
          this.$intro().hideHints();
        },

        findByKeyAndRemove (source, key, id) {
            if (source) {
                for (var i = 0; i < source.length; i++) {
                    if (source[i][key] === id) {
                        source.splice(key, 1);
                    }
                }
                return false;
            }else {
                return false;
            }
        },
        findByKeyAndReplace (source, key, id, data) {
            for (var i = 0; i < source.length; i++) {
                if (source[i][key] === id) {
                    source[i] = data;
                }
            }
            return false;
        },
        findByKey (source, key, find) {
            if (source) {
                for (var i = 0; i < source.length; i++) {
                    if (source[i][key] === find) {
                        return source[i];
                    }
                }
                return false;
            }else {
                return false;
            }
        },
        uformat (str, args) {

            $.each(args, function(key, value) {
                str = str.replace(new RegExp("\\%" + key + "\\%", "gi"), value);
            });

            return str;
        },
        phpToMoment(str) {
            let replacements = {
                'd' : 'DD',
                'D' : 'ddd',
                'j' : 'D',
                'l' : 'dddd',
                'N' : 'E',
                'S' : 'o',
                'w' : 'e',
                'z' : 'DDD',
                'W' : 'W',
                'F' : 'MMMM',
                'm' : 'MM',
                'M' : 'MMM',
                'n' : 'M',
                't' : '', // no equivalent
                'L' : '', // no equivalent
                'o' : 'YYYY',
                'Y' : 'YYYY',
                'y' : 'YY',
                'a' : 'a',
                'A' : 'A',
                'B' : '', // no equivalent
                'g' : 'h',
                'G' : 'H',
                'h' : 'hh',
                'H' : 'HH',
                'i' : 'mm',
                's' : 'ss',
                'u' : 'SSS',
                'e' : 'zz', // deprecated since Moment.js 1.6.0
                'I' : '', // no equivalent
                'O' : '', // no equivalent
                'P' : '', // no equivalent
                'T' : '', // no equivalent
                'Z' : '', // no equivalent
                'c' : '', // no equivalent
                'r' : '', // no equivalent
                'U' : 'X'
            };

            return str.split('').map(chr => chr in replacements ? replacements[chr] : chr).join('');
        },
        dateTimeFormat (date) {
            var stillUtc = window.moment.utc(date).toDate();
            var local = window.moment(stillUtc).local().format(this.phpToMoment(session.date_time_format));

            return local
        },
        _df (date) {
            return window.moment(date).format(this.phpToMoment(session.date_format), { trim: false })
        },
        dateNow () {
            var myDate = new Date();
            var myDate_string = myDate.toISOString();
            var myDate_string = myDate_string.replace("T"," ");
            var myDate_string = myDate_string.substring(0, myDate_string.length - 5);
            return myDate_string;
        },
        sortByKey(array, key) {
            return array.sort(function(a, b) {
                var x = a[key]; var y = b[key];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });
        },
        moment(date) {
            return window.moment(date);
        },
        controlPanel () {
            if (this.$root.panelActive) {
                this.$root.panelActive = false;
            }else {
                this.$root.panelActive = true;
            }

            this.$bus.$emit('openPanel',this.$root.panelActive);
        },
        fixBodyScroll () {
            setTimeout( () => {
                document.body.style.overflow='auto';
            },  600);
        },
        periodTimer (m) {

            if(m.periodTimeLeft != 0){

                return m.periodTimeLeft;

            }else if(m.periodTime > 0){
                const min = (m.periodTime / 60).toFixed(0);

                return (min > 0) ? min+"'" : '';
            }

            if(m.periodCounter > 0){
                const min = (m.roundCounter / 3600).toFixed(2);

                return (min > 0) ? min+"'" : '';
            }
        },
        timer (date) {
            // Set the date we're counting down to
            var countDownDate = new Date(date).getTime();


            // Get todays date and time
            var now = new Date().getTime();

            // Find the distance between now an the count down date
            var distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // Display the result in the element with id="demo"

            return moment(date).fromNow(true);

        },
      async groupsCh () {
        var e = document.getElementsByClassName("choicesx");
        for (var i = 0; i < e.length; i++){
          var name = e[i].getAttribute("name");

          var element = e[i];

          var example = new Choices(element, {
            removeItemButton: true,

          });
        }
      },
    },
    filters: {
        uformat: function (str, args) {

            args.forEach(myFunction)

            for (var a in args) {
                str = str.replace(new RegExp("\\%" + a.key + "\\%", "gi"), a);
            }


            return unescape(str);
        },
        toMoney: function (val,currency,symbol = true) {

          if (!currency) {
                        return accounting.formatMoney(val, {
                          format:  formatConfig,
                          symbol: '',
                          precision : 2,
                          thousand : ',',
                          decimal : '.',
                      });
          }

            if (!currency)
                return false;

            let formatConfig = "%s %v"


            if (currency.position === 'before'){
                formatConfig = "%s %v";
            } else {
                formatConfig = "%v %s";
            }

            var mony = accounting.formatMoney(val, {
                format:  formatConfig,
                symbol: currency.symbol,
                precision : 2,
                thousand : ',',
                decimal : '.',
            });

            if(currency.position == 'before'){
                if(symbol) {
                    return mony;
                }else {
                    return currency.iso_code+' '+mony;
                }
            }else {
                if(symbol) {
                    return mony;
                }else {
                    return mony+' '+currency.iso_code;
                }
            }
        },
        moment: function (date,format,tz) {
            if(date){
                return (format && tz) ? window.moment(date).format(format, { trim: false }) : date;
            }
        },
        tz: function (dt,tz,format,ago = true) {
            window.moment.tz.add(tz)
            if(ago){
                return (dt && tz) ? window.moment(dt).fromNow() : '--'; // 5 years ago
            }else {
                return (dt && tz) ? window.moment(dt).format(format, { trim: false }) : '--'; // 5 years ago
            }
        },
        timeAgo: function (dt) {
            //window.moment.tz.add(window.session.date_time_format);
            return (dt) ? window.moment(dt).fromNow() : '';
        },
        slimiter: function(str, limit) {
            return (str.length > limit) ? str.substring(0,limit)+'...' : str;
        },
        nPlus: function (number) {
            return (number > 90) ? '90+' : number;
        },
        arrayFragmentation: function (Array, n = 6) {
            var count = Array.length;
            var newArray = new Array();

            for(i = 0; i <= count;) {
                newArray[i] = Array.slice(i, n);
                i++;
            }
        },

    }
}

Vue.mixin(mixin);



// WEBPACK FOOTER //
// ./src/main.js